<template>
  <div class="card" style="margin-bottom: 0">
    <div class="card-title">解禁提示</div>
    <div class="wrap">
      <div style="display: flex; align-items: center; margin-top: 16px">
        <CCascader
          @CCascader_select_node="fnCCascader_select_val_chart3"
          :default="da_lei_default_value"
          :checkStrictly="true"
          :multiple="true"
          :collapsetags="true"
          :options="category_cascader_options"
          >选择类别
        </CCascader>
        <CCascader
          custWidth="250px"
          style="margin-left: 16px"
          :checkStrictly="false"
          :multiple="true"
          :isDelete="false"
          :default="reit_code_default"
          placeholder="请选择个股"
          :collapsetags="true"
          @CCascader_select_val="fnSelect_select_val_chart1_codename"
          :options="CODENAMEDATA">
          选择对比REITs
        </CCascader>
        <div style="margin-left: 16px; display: flex; align-items: center">
          解禁到期频率
          <CButtons
            style="margin-left: 10px"
            :dButtons1="select_2"
            :dButtons1_current="select_2_default"
            @Cbtns_sep="select2Change" />
          <el-tooltip
            style="margin-left: 4px"
            class="item"
            effect="dark"
            content="当选择日为频率时，最多显示1年内的解禁到期，当选择月时显示3年到期，选择年时，不设置时间段限制"
            placement="right">
            <i
              class="el-icon-question"
              style="font-size: 20px; margin-left: 16px; color: rgb(64, 158, 255)"></i>
          </el-tooltip>
        </div>
        <DateTimePick v-model="date_1" :clearable="false" />
        <el-checkbox v-model="checked" />&nbsp;&nbsp;是否剔除原始权益人
        <div style="margin-left: auto; margin-right: 0">
          <Download
            :dButtonsDownloads="dButtonsDownloads"
            :excel_info="excel_info"
            echartRefName="chaert1Ref" />
        </div>
      </div>
      <div
        class="iconfont icon-fangda"
        style="top: 105px; right: 92px"
        @click="show_chart_dialog = true"></div>
      <div ref="chaert1Ref" style="width: 100%; height: 450px; margin-top: 30px"></div>
      <div style="margin-top: 30px">
        <el-table
          class="table1"
          :header-cell-style="tableStyle"
          :data="page_data"
          height="500"
          style="width: 100%"
          @cell-click="fnClick">
          <el-table-column type="index" width="80" label="序号" />
          <el-table-column width="150" sortable label="解禁时间" prop="restrict_date" />
          <el-table-column min-width="200" label="REITs简称" prop="reit_name" />
          <el-table-column width="150" label="代码" prop="reit_code" />
          <el-table-column width="100" label="大类" prop="category_1" />
          <el-table-column width="150" label="细分" prop="category_2" />
          <el-table-column min-width="200" label="解禁份额(万份)" prop="total_restrict_shares" />
          <el-table-column width="150" label="解禁占比" prop="res_proportion">
            <template slot-scope="scope">
              {{ (scope.row.res_proportion * 100).toFixed(2) + '%' }}
            </template>
          </el-table-column>
          <el-table-column min-width="200" label="解禁金额(亿元)" prop="res_amt">
            <template slot-scope="scope">
              {{ scope.row.res_amt.toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ChartDialog
      :show.sync="show_chart_dialog"
      :echart_options="chart_dialog_options"
      :sty1="{ dataZoom: { endValue: x_ray_total.length - 30 } }"
      :sty2="{ dataZoom: { endValue: x_ray_total.length - 10 } }"
      :sty3="{ dataZoom: { endValue: x_ray_total.length - 30 } }" />
  </div>
</template>

<script>
import ChartDialog from '@/components/Basic/ChartDialog.vue';
import Download from '@/components/Basic/Download.vue';
import { fnReturnTableStyle } from '@/utils/util';
import { getDateInfo } from '@/utils';
import CCascader from '@/components/Basic/CCascader';
import CButtons from '@/components/Basic/CButtons_separate.vue';
import DateTimePick from '@/components/Basic/DateTimePick1';
export default {
  name: 'Six',
  components: { CCascader, CButtons, Download, ChartDialog, DateTimePick },
  data() {
    const CATEGORYDATA = JSON.parse(localStorage.getItem('CATEGORYDATA')) || [];
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    return {
      ROOTFONTFIZE: '',
      excel_info: Object.freeze({
        overviewName: '解禁提示',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      da_lei_default_value: ['公募REITs'],
      category_cascader_val_chart3: ['公募REITs'],
      category_cascader_options: Object.freeze(CATEGORYDATA),
      reit_code_default: [],
      CODENAMEDATA: Object.freeze(REITsNAME),
      reit_code: [],
      select_2: Object.freeze(['年', '月', '日']),
      select_2_default: '月',
      checked: false,
      x_ray_total: [],
      page_data: [],
      show_chart_dialog: false,
      chart_dialog_options: {},
      date_1: ['', ''],
    };
  },
  computed: {
    qsStr() {
      const r_type = this.category_cascader_val_chart3.join('&r_type=');
      const codes = this.reit_code.join('&codes=');
      const freq_map = {
        年: 'Y',
        月: 'M',
        日: 'D',
      };
      const freq = freq_map[this.select_2_default];
      const del_origin = this.checked ? 1 : 0;
      const start_date = this.date_1[0] ? getDateInfo(this.date_1[0]).dateString : '';
      const end_date = this.date_1[1] ? getDateInfo(this.date_1[1]).dateString : '';
      return `r_type=${r_type}&codes=${codes}&freq=${freq}&del_origin=${del_origin}&start_date=${start_date}&end_date=${end_date}`;
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    qsStr() {
      this.loadData();
    },
    currentTheme(newVal, oldVal) {
      setTimeout(() => {
        this.chart1();
      }, 0);
    },
  },
  mounted() {
    const colors = this.$store.state.colors || [];
    this.category_2_color_map = colors.reduce((p, c) => {
      p[c.name] = c.value;
      return p;
    }, {});
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart1_instance && this.echart1_instance.dispose();
    this.echart1_instance = null;
  },
  methods: {
    fnClick(row, column, cell) {
      if (row.reit_code) {
        let arr = [row['reit_name'], row['reit_code']];
        this.$eventBus.$emit('skipPage', arr);
      }
    },
    select2Change(v) {
      this.select_2_default = v;
    },
    fnCCascader_select_val_chart3(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.category_cascader_val_chart3 = val;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return;
    },
    resize() {
      this.fnGetWidth();
      this.echart1_instance && this.echart1_instance.resize();
    },
    chart1() {
      // console.clear();
      if (!this.echart1_instance) {
        this.echart1_instance = this.$echarts.init(this.$refs.chaert1Ref);
      }
      this.echart1_instance.clear();
      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const x_ray_total = this.x_ray_total;
      const data = this.page_data;
      const reits_item = [...new Set(data.map((item) => item.reit_name))];
      const reits_data = reits_item.reduce((p, c) => {
        p[c] = data.filter(({ reit_name }) => reit_name === c);
        return p;
      }, {});
      const getItemColor = (c2) => {
        return this.category_2_color_map[c2] || '#bfabfa';
      };
      const series = Object.keys(reits_data).map((k) => {
        return {
          name: k,
          type: 'bar',
          stack: 'stack',
          data: reits_data[k].map(
            ({
              reit_code,
              restrict_date,
              total_restrict_shares,
              reit_name,
              category_1,
              category_2,
              xRay,
              unit_total,
              close,
              res_proportion,
              res_amt: y,
              'x-ray': x,
            }) => [x, y /* category_1, category_2 */]
          ),
          barWidth:
            this.select_2_default !== '年' ? this.ROOTFONTFIZE * (30 / 144) + 'px' : undefined,
          itemStyle: {
            color: getItemColor(reits_data[k][0].category_2),
          },
        };
      });

      // const startValue = x_ray_total.length;
      const startValue = 0;
      const endValue = startValue - 45;

      const options = {
        series,
        legend: {
          show: true,
          orient: 'vertical',
          top: 40,
          right: 0,
          align: 'left',
          icon: 'roundRect',
          itemGap: 5,
          itemHeight: 5,
          height: 380,
          padding: [0, 0, 0, 0],
          type: 'scroll',
          pageIconColor: 'blue',
          pageIconInactiveColor: OPTIONDATA.legend.textStyle.color,
          pageTextStyle: {
            color: OPTIONDATA.legend.textStyle.color,
          },
          lineStyle: {
            color: 'inherit',
          },
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: OPTIONDATA.legend.textStyle.fontSize,
            width: this.ROOTFONTFIZE * (180 / 144),
            overflow: 'break',
          },
        },
        tooltip: {
          formatter: ({ seriesName, value, marker }) => {
            const [x, y] = value;
            return `${x}<br/><div>${marker} ${seriesName} ${y.toFixed(2)}</div>`;
          },
        },
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        dataZoom: {
          // 开启数据平移qc
          type: 'slider', // 滑动条单独显示
          show: x_ray_total.length > 35, // 是否显示滑动条
          startValue, // 展示区域内容的起始数值
          endValue, // 展示区域内容的结束数值 当前展示x坐标下标为0-16
          height: this.ROOTFONTFIZE * (5 / 144), // 滑动条组件高度
          bottom: this.ROOTFONTFIZE * (20 / 144), // 距离图表区域下边的距离
          showDetail: false, // 拖拽时是否显示详情
          showDataShadow: false,
          fillerColor: '#D4D4D4', // 平移条的填充颜色
          borderColor: 'transparent', // 边框颜色
          zoomLock: true, // 锁定视图
          brushSelect: false, // 不可缩放 滑动条默认是有手柄可以进行展示的内容区域缩放的，不太美观
          // 通过该属性可以只滑动，不显示缩放功能
          handleStyle: {
            opacity: 0,
          },
          lineStyle: {
            opacity: 0,
          },
          textStyle: {
            fontSize: 0,
          },
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: this.select_2_default === '日' ? 45 : this.select_2_default === '月' ? 35 : 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
          data: x_ray_total,
        },
        yAxis: {
          name: '单位(亿元)',
          nameTextStyle: {
            color: OPTIONDATA.yAxis.nameTextStyle.color,
            fontSize: OPTIONDATA.yAxis.nameTextStyle.fontSize,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            show: true,
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
        },
        grid: {
          top: this.ROOTFONTFIZE * (60 / 144),
          left: this.ROOTFONTFIZE * (35 / 144),
          right: this.ROOTFONTFIZE * (200 / 144),
          bottom: this.ROOTFONTFIZE * (30 / 144),
          containLabel: true,
        },
      };
      this.chart_dialog_options = Object.freeze(options);
      this.echart1_instance.setOption(options);
      this.echart1_instance.resize();
    },
    async loadData() {
      const qs = this.qsStr;
      const { data } = await this.$https.get(`/api/v2_5/investor_restrict_remind?${qs}`);
      if (data.code !== 200) return this.$message.error(data.msg);
      if (!Object.keys(data.data).length) {
        this.$message.error('暂无数据');
        return;
      }
      this.page_init = true;
      const { x_ray_total, result } = data.data;
      this.x_ray_total = Object.freeze(x_ray_total);
      this.page_data = Object.freeze(result);
      if (this.page_data) {
        setTimeout(() => {
          this.excel_info = Object.freeze({
            overviewName: this.excel_info.overviewName,
            excel_data: this.page_data,
            json_fields: {
              代码: 'reit_code',
              REITs简称: 'reit_name',
              大类: 'category_1',
              细分: 'category_2',
              解禁时间: 'restrict_date',
              '解禁份额(万分)': 'total_restrict_shares',
              解禁占比: 'res_proportion',
              '解禁金额(亿元)': 'res_amt',
            },
          });
          this.chart1();
        }, 0);
      }
    },
    pageInit() {
      if (this.page_init) {
        setTimeout(() => {
          this.resize();
        }, 100);
        return;
      }
      this.loadData();
    },
  },
};
</script>

<style scoped lang="less">
.card {
  background-color: rgba(29, 31, 37, 1);
  background-color: var(--charts_bgc);
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-top: calc(var(--ROOTFONTFIZE) * (15 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  height: auto;
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  .card-title {
    color: var(--chart_title);
    font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
    font-weight: 700;
    // border-left: 5px solid #1573fe;
    border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
    padding-left: calc(var(--ROOTFONTFIZE) * (10 / 144));
    position: relative;
  }
  .wrap {
    position: relative;
    width: 97%;
    margin: auto;
    padding-top: 20px;
    .container {
      margin-left: 0;
    }
  }
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
